import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { formattedCountryData, personalDocuments } from '../../../common/utils/formattedData';
import { updateDoctorPersonalInfo as updateDoctorInfo } from '../api/updateDoctorPersonalInfo';
import {
    updatePatientPersonalInfo as updatePatientInfo,
    updatePatientPersonalInfoFile
} from '../api/updatePatientPersonalInfo';
import defaultImage from '../../../images/profile.png';
import moment from 'moment';
const useInitialForm = (userType, userProfile, userId, diseases,setDiseases,setDiseaseErrors) => {

    const APP_SERVER = process.env.REACT_APP_API_SERVER;
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [previewImage, setPreviewImage] = useState(
        userProfile.personalImage ? `${APP_SERVER}/${userProfile.personalImage}` : defaultImage
    );
    const nationality = formattedCountryData.find((nationality) => (nationality.label = userProfile?.nationality));
    
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        setValue,
        getValues,
        trigger,
        watch
    } = useForm({
        defaultValues: {
            ...userProfile,
            nationality,
            birthDate: moment(userProfile?.birthDate).format('DD/MM/YYYY'),            
            picture: '',
            diseases: userProfile?.diseases
            

        }
    });
       const code = watch('countryCode');

  
    const validateDiseases = () => {
        const hasEmpty = diseases?.some(d => d.name.trim() === "");
        return !hasEmpty;
    };
   const saveProfileForm = async ({
  phone,
  picture,
  personalImage,
  birthDate,
  address,
  country,
  state,
  firstName,
  lastName,
  gender,
  blood_type,
  weight,
  height
}) => {
  if (!validateDiseases()) {
    setDiseaseErrors(diseases.map(d => d.name.trim() === "" ? "Este campo no puede estar vacío" : ""));
    setShowErrorModal(true);
    return;
  }

  setIsLoading(true);

  const onFail = () => {
    setShowErrorModal(true);
  };

  let formData = new FormData();

const safeAppend = (key, value) => {
  if (value !== undefined && value !== null && value !== '') {
    formData.append(key, value);
  }
};

safeAppend('phone', phone);
safeAppend('firstName', firstName);
safeAppend('lastName', lastName);
safeAppend('personalImage', personalImage);
safeAppend('birthDate', birthDate ? moment(birthDate, 'DD/MM/YYYY').format('YYYY-MM-DD') : null);
safeAppend('address', address);
safeAppend('country', country);
safeAppend('state', state);
safeAppend('countryCode', code);
safeAppend('diseases', diseases ? JSON.stringify(diseases) : null);
safeAppend('gender', gender);
safeAppend('blood_type', blood_type);
safeAppend('weight', weight);
safeAppend('height', height);
safeAppend('documentType', getValues('documentType'));
safeAppend('personalDocument', getValues('personalDocument'));



  const data =
    userType === 'doctor'
      ? await updateDoctorInfo(userId, { phone, picture }, onFail)
      : await updatePatientPersonalInfoFile(userId, formData);

  setIsLoading(false);

  if (data?.status == 201) {
    setShowSuccessModal(true);
    setDiseases(['']);
  }
};

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setValue('personalImage', file);
        trigger('personalImage', { shouldValidate: true });
        setPreviewImage(URL.createObjectURL(file));
    };
    const onCloseErrorMessage = () => {
        setShowErrorModal(false);
    };

    const onCloseSuccessMessage = () => {
        setShowSuccessModal(false);
    };

    return {
        formattedCountryData,
        register,
        handleSubmit,
        setValue,
        getValues,
        errors,
        saveProfileForm,
        control,
        personalDocuments,
        showErrorModal,
        isLoading,
        showSuccessModal,
        onCloseErrorMessage,
        onCloseSuccessMessage,
        handleImageChange,
        previewImage,
        watch
    };
};

export default useInitialForm;
